<template>
    <div>
        <b-modal no-close-on-backdrop no-close-on-esc centered hide-header hide-footer size="sm" body-class="align-items-center d-flex justify-content-around" v-model="showSpinner"><b-spinner></b-spinner> <span>Processing your input ...</span></b-modal>
        <b-row v-if="quote == null">
            <b-col lg="6" xl="4">
                <validation-observer v-slot="{ handleSubmit }" slim>
                    <b-card class="mb-1 h-100" footer-class="d-flex justify-content-end">
                       
                        <!--<b-form-group label="Do you have an account with Epiq ?"
                                      v-slot="{ ariaDescribedby }"
                                      v-if="currentClientUserAccount == null">
                            <b-form-radio-group v-model="hasExistingAccount"
                                                :options="[ { text: 'No', value: false }, { text: 'Yes', value: true }]"
                                                :aria-describedby="ariaDescribedby"
                                                :disabled="true || (currentStep != 1)"
                                                button-variant="outline-primary"
                                                buttons></b-form-radio-group>
                        </b-form-group>-->

                        <template v-if="(hasExistingAccount === true) && (currentClientUserAccount == null)">
                            <b-form v-if="!showForgottenPasswordForm">
                                <b-form-group label="Email:" label-for="email-input">
                                    <b-form-input id="email-input" v-model="loginEmail" type="email" placeholder="Enter email" required />
                                </b-form-group>

                                <b-form-group label="Password:" label-for="password-input">
                                    <b-form-input id="password-input" v-model="loginPassword" placeholder="Enter password" required />
                                </b-form-group>

                                <b-button v-on:click="forgotPassword()" class="mr-1" variant="warning">Forgot Password</b-button>
                                <b-button type="submit" v-on:click="login()" variant="primary">Login</b-button>
                            </b-form>

                            <b-form v-if="showForgottenPasswordForm">
                                <b-form-group>
                                    <p>Please provide your account emails and click REQUEST ACCESS. An email with furhter instructions will be sent to the email address provided.</p>
                                    <b-form-input id="email-input" v-model="loginEmail" type="email" placeholder="Enter email" required />
                                </b-form-group>
                                <b-button type="submit" class="mr-2" v-on:click="backToLogin()" variant="warning">Back to Login</b-button>
                                <b-button type="submit" v-on:click="requestPassword()" variant="primary">Request Access</b-button>
                            </b-form>
                        </template>

                        <template v-if="(hasExistingAccount === false) || (currentClientUserAccount != null)">

                            <h5>Please Provide General Information</h5>
                            <validation-provider rules="required" name="Firm/Organisation" v-slot="{ errors }" slim>
                                <b-form-group label="Firm/Organisation:" label-for="clientName">
                                    <b-form-input name="clientName"
                                                  v-model="quoteRequest.clientName"
                                                  placeholder="Enter Firm/Organisation name"
                                                  :readonly="(currentStep != 1) || ((currentClientUserAccount != null) && (currentClientUserAccount.clientName != null))"
                                                  :state="errors[0] ? false : null" />
                                    <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider rules="required" name="First Name" v-slot="{ errors }" slim>
                                <b-form-group label="First Name:" label-for="contactGivenNames">
                                    <b-form-input name="contactGivenNames"
                                                  v-model="quoteRequest.contactGivenNames"
                                                  placeholder="Enter first name"
                                                  :readonly="currentStep != 1"
                                                  :state="errors[0] ? false : null" />
                                    <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider rules="required" name="Last Name" v-slot="{ errors }" slim>
                                <b-form-group label="Last Name:" label-for="contactLastName">
                                    <b-form-input name="contactLastName"
                                                  v-model="quoteRequest.contactLastName"
                                                  placeholder="Enter last name"
                                                  :readonly="currentStep != 1"
                                                  :state="errors[0] ? false : null" />
                                    <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>

                            <b-form-group label="Email Addresses:" label-for="email" :description="'All corresondence will be sent to ' + (quoteRequest.contactEmails.length > 1 ? 'these email addresses' : 'this email address')">
                                <validation-provider rules="required|email" :name="'Email Address ' + (emailIndex + 1)" v-slot="{ errors }" slim v-for="(emailAddress,emailIndex) in quoteRequest.contactEmails" v-bind:key="emailIndex">
                                    <b-input-group :class="errors[0] ? 'is-invalid' : ''">
                                        <b-input-group-prepend>
                                            <button class="btn btn-outline-secondary" disabled type="button">
                                                {{ emailIndex + 1 }}
                                            </button>
                                        </b-input-group-prepend>
                                        <b-form-input v-model="quoteRequest.contactEmails[emailIndex]"
                                                        type="text"
                                                        :placeholder="'Enter email address ' + (emailIndex + 1)"
                                                        :readonly="(currentStep != 1) || (currentClientUserAccount != null)"
                                                        :state="errors[0] ? false : null" />
                                        <b-input-group-append v-if="emailIndex==0">
                                            <button @click="addAdditionalEmail()" class="btn btn-outline-success" type="button" style="width: 40px;">
                                                <strong>+</strong>
                                            </button>
                                        </b-input-group-append>
                                        <b-input-group-append v-else>
                                            <button @click="removeAdditionalEmail(emailIndex)" class="btn btn-outline-danger" type="button" style="width: 40px;">
                                                <strong>-</strong>
                                            </button>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                                </validation-provider>
                            </b-form-group>

                            <b-form-group label="Phone Numbers:" label-for="phoneNumber">
                                <validation-provider rules="required" :name="'Phone Number ' + (contactPhoneIndex + 1)" v-slot="{ errors }" slim v-for="(contactPhone,contactPhoneIndex) in quoteRequest.contactPhoneNumbers" v-bind:key="contactPhoneIndex">
                                    <b-input-group :class="errors[0] ? 'is-invalid' : ''">
                                        <b-input-group-prepend>
                                            <button class="btn btn-outline-secondary" disabled type="button">
                                                {{ contactPhoneIndex + 1 }}
                                            </button>
                                        </b-input-group-prepend>
                                        <b-form-input name="contactPhone"
                                                      v-model="quoteRequest.contactPhoneNumbers[contactPhoneIndex]"
                                                      type="text"
                                                      :placeholder="'Enter phone number ' + (contactPhoneIndex + 1)"
                                                      :readonly="(currentStep != 1) || (currentClientUserAccount != null)"
                                                      :state="errors[0] ? false : null" />
                                        <b-input-group-append v-if="contactPhoneIndex==0">
                                            <button @click="addAdditionalPhoneNumber()" class="btn btn-outline-success" type="button" style="width: 40px;">
                                                <strong>+</strong>
                                            </button>
                                        </b-input-group-append>
                                        <b-input-group-append v-else>
                                            <button @click="removeAdditionalPhoneNumber(contactPhoneIndex)" class="btn btn-outline-danger" type="button" style="width: 40px;">
                                                <strong>-</strong>
                                            </button>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                                </validation-provider>
                            </b-form-group>

                        </template>

                        <template #footer v-if="hasExistingAccount != null && currentStep == 1">
                            <b-button @click="handleSubmit(onNext)" v-if="(hasExistingAccount === false) || (currentClientUserAccount != null)" :disabled="currentStep != 1">Next</b-button>
                        </template>
                    </b-card>
                </validation-observer>
            </b-col>
            <b-col lg="6" xl="4" v-if="currentStep >= 2">
                <validation-observer v-slot="{ handleSubmit }" slim>
                    <b-card class="mb-1 h-100" footer-class="d-flex justify-content-end">
                        <validation-provider rules="required" name="Order Type" v-slot="{ errors }" slim>
                            <b-form-group label-for="quoteOrderTypeSelect" label="Order Type:">
                                <select2 ref="quoteOrderTypeSelect"
                                         name="quoteOrderTypeSelect"
                                         key="quoteOrderTypeSelect"
                                         placeholder="Select an order type"
                                         :options="quoteOrderTypes"
                                         key-property="quoteOrderTypeId"
                                         text-property="name"
                                         disable-search
                                         allow-clear
                                         v-model="quoteRequest.quoteOrderTypeId"
                                         :disabled="currentStep != 2"
                                         :state="errors[0] ? false : null"
                                         v-on:select="quoteOrderTypeSelectionChanged"></select2>
                                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </validation-provider>

                        <template v-if="(selectedQuoteOrderType != null) && (selectedQuoteOrderType.detailsScreenType == 1)"> 
                            <validation-provider name="Matter Description" v-slot="{ errors }" slim>
                                <b-form-group label-for="courtMatterDescription" label="Matter Description:">
                                    <b-form-textarea name="courtMatterDescription"
                                                     v-model="quoteRequest.matterInformation"
                                                     rows="10"
                                                     placeholder="Enter a description for the matter"
                                                     :disabled="currentStep != 2"
                                                     :state="errors[0] ? false : null" />
                                    <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider rules="required" name="Court" v-slot="{ errors }" slim>
                                <b-form-group label-for="courtRegistrySelect" label="Court:">
                                    <select2 ref="courtRegistrySelect"
                                             name="courtRegistrySelect"
                                             key="courtRegistrySelect"
                                             placeholder="Select a court/tribunal/other"
                                             :options="courtRegistries"
                                             key-property="courtRegistryId"
                                             text-property="name"
                                             disable-search
                                             allow-clear
                                             v-model="quoteRequest.courtRegistryId"
                                             :disabled="currentStep != 2"
                                             :state="errors[0] ? false : null"
                                             v-on:select="courtRegistrySelectionChanged"></select2>
                                    <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider rules="required" name="Jurisdiction" v-slot="{ errors }" slim>
                                <b-form-group label-for="courtJurisdictionSelect" label="Jurisdiction">
                                    <select2 name="courtJurisdictionSelect"
                                             key="courtJurisdictionSelect"
                                             :placeholder="courtJurisdictionSelectPlaceholder"
                                             :options="courtJurisdictions"
                                             key-property="courtJurisdictionId"
                                             text-property="name"
                                             disable-search
                                             allow-clear
                                             :disabled="(currentStep != 2) || (quoteRequest.courtRegistryId == null)"
                                             :state="errors[0] ? false : null"
                                             v-model="quoteRequest.courtJurisdictionId"></select2>
                                    <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </template>

                        <template v-if="(selectedQuoteOrderType != null) && (selectedQuoteOrderType.detailsScreenType == 9)">
                            <validation-provider rules="required" name="Matter Description" v-slot="{ errors }" slim>
                                <b-form-group label-for="matterInformation" label="Matter Description:">
                                    <b-form-textarea name="matterInformation"
                                                     v-model="quoteRequest.matterInformation"
                                                     rows="10"
                                                     placeholder="Enter a description for the matter"
                                                     :disabled="currentStep != 2"
                                                     :state="errors[0] ? false : null" />
                                    <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider rules="required" name="Location" v-slot="{ errors }" slim>
                                <b-form-group label-for="locationSelect" label="Location">
                                    <select2 name="locationSelect"
                                             key="locationSelect"
                                             placeholder="Select a location"
                                             :options="locationOptions"
                                             disable-search
                                             allow-clear
                                             :disabled="currentStep != 2"
                                             :state="errors[0] ? false : null"
                                             v-model="quoteRequest.location"></select2>
                                    <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </template>

                        <template #footer v-if="currentStep == 2">
                            <b-button @click="onBack" :disabled="currentStep != 2" class="mr-1">Back</b-button>
                            <b-button @click="handleSubmit(onNext)" :disabled="currentStep != 2">Next</b-button>
                        </template>
                    </b-card>
                </validation-observer>
            </b-col>
            <b-col lg="6" xl="4" v-if="currentStep >= 3">
                <validation-observer v-slot="{ handleSubmit }" slim>
                    <b-card class="mb-1 h-100" footer-class="d-flex justify-content-end">
                        <validation-provider rules="required" name="Sitting Date/s" v-slot="{ errors }" slim>
                            <b-form-group label-for="sittingDatesCalendar" label="Sitting Date/s" :state="errors[0] ? false : null" :invalid-feedback="errors[0]">
                                <ejs-calendar :showTodayButton="false" :isMultiSelection="true" v-model="sittingDate" :values="quoteRequest.sittingDates" @change="sittingDatesSelectionChanged" :enabled="currentStep == 3"></ejs-calendar>
                            </b-form-group>
                        </validation-provider>
                        <validation-provider rules="required" name="Estimated Duration" v-slot="{ errors }" slim>
                            <b-form-group label="Estimated duration" label-for="duration" label-cols-md="6" :state="errors[0] ? false : null" :invalid-feedback="errors[0]">
                                <b-input-group>

                                    <b-form-input name="duration" 
                                                  maxlength="4" 
                                                  @keydown.native="validatePositiveInteger" 
                                                  v-model="quoteRequest.estimatedDuration" 
                                                  :state="errors[0] ? false : null" 
                                                  :readonly="currentStep != 3 || (quoteRequest.estimatedDurationUnits == 'Days' && quoteRequest.estimatedDuration > 1)" />
                                    
                                    <b-form-select v-model="quoteRequest.estimatedDurationUnits" :disabled="currentStep != 3" @change="recalculateUnits">
                                        <b-form-select-option value="Minutes">minutes</b-form-select-option>
                                        <b-form-select-option value="Hours">hours</b-form-select-option>
                                        <b-form-select-option value="Days">days</b-form-select-option>
                                    </b-form-select>
                                </b-input-group>
                            </b-form-group>
                        </validation-provider>
                        <template v-if="currentStep >= 4">
                            <template v-if="(serviceTypes == null) || (serviceTypes.length == 0)">
                                <b-alert show variant="info">We do not offer an estimate for your specific selection. Please either select other options or call us directly on 1 300 1234567.</b-alert>
                            </template>
                            <template v-if="(serviceTypes != null) && (serviceTypes.length > 0)">
                                <validation-provider rules="required" name="Service Type" v-slot="{ errors }" slim>
                                    <b-form-group label-for="serviceTypeSelect" label="Service Type">
                                        <select2 ref="serviceTypeSelect"
                                                 name="serviceTypeSelect"
                                                 key="serviceTypeSelect"
                                                 :placeholder="serviceTypeSelectPlaceholder"
                                                 :options="serviceTypes"
                                                 key-property="serviceTypeId"
                                                 text-property="name"
                                                 disable-search
                                                 allow-clear
                                                 :disabled="(selectedQuoteOrderType == null) || ((selectedQuoteOrderType.detailsScreenType == 1) && (quoteRequest.courtRegistryId == null))"
                                                 :state="errors[0] ? false : null"
                                                 v-model="quoteRequest.serviceTypeId"
                                                 v-on:select="serviceTypeSelectionChanged"></select2>
                                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </validation-provider>
                                <template v-if="selectedServiceType && selectedServiceType.requiresServiceDelay">
                                    <validation-provider rules="required" name="Turnaround" v-slot="{ errors }" slim>
                                        <b-form-group label-for="serviceDelaySelect" label="Turnaround">
                                            <select2 name="serviceDelaySelect"
                                                     key="serviceDelaySelect"
                                                     placeholder="Select a turnaround"
                                                     :options="serviceDelays"
                                                     key-property="serviceDelayId"
                                                     text-property="name"
                                                     disable-search
                                                     allow-clear
                                                     :state="errors[0] ? false : null"
                                                     v-model="quoteRequest.serviceDelayId"></select2>
                                            <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>
                                </template>
                            </template>
                        </template>
                        <template #footer v-if="(currentStep == 3) || (currentStep == 4)">
                            <b-button @click="onBack" class="mr-1">Back</b-button>
                            <b-button @click="handleSubmit(onNext)" v-if="(currentStep == 3) || ((serviceTypes != null) && (serviceTypes.length > 0))">{{ (currentStep == 3) ? 'Next' : 'Request Estimate' }}</b-button>
                        </template>
                    </b-card>
                </validation-observer>

            </b-col>
        </b-row>
        
        <div id="panel2" style="width:100%;" v-if="quote != null">
            <div id="quoteResult" class="box">

                <b-table-simple stacked>

                    <h5>Estimate Summary</h5>

                    <b-tr>
                        <b-td>Firm/Organisation:</b-td>
                        <b-td>{{ quote.clientName }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-td>First Name:</b-td>
                        <b-td>{{ quote.contactGivenNames }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-td>Last Name:</b-td>
                        <b-td>{{ quote.contactLastName }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-td>Email:</b-td>
                        <b-td>
                            <div v-html="explodeEmails(quote.contactEmail)"></div>
                       </b-td>
                    </b-tr>
                    <b-tr>
                        <b-td>Mobile Number:</b-td>
                        <b-td>
                            <div v-html="explodeEmails(quote.contactPhone)"></div>
                        </b-td>
                    </b-tr>
                    <b-tr>
                        <b-td>Sitting Dates:</b-td>
                        <b-td>
                            <template v-for="sittingDate in quote.sittingDates">
                                {{ formatDateTime(sittingDate, 'DD/MM/YYYY') }}
                            </template>
                        </b-td>
                    </b-tr>
                    <b-tr>
                        <b-td>Duration:</b-td>
                        <b-td>{{ quote.estimatedDuration }} {{ quote.estimatedDurationUnitsDisplayName }} </b-td>
                    </b-tr>
                    <b-tr>
                        <b-td>Order Type:</b-td>
                        <b-td>{{ quote.quoteOrderTypeName }}</b-td>
                    </b-tr>
                    <b-tr v-if="quote.courtRegistryId">
                        <b-td>Court:</b-td>
                        <b-td>{{ quote.courtRegistryName }}</b-td>
                    </b-tr>
                    <b-tr v-if="quote.courtJurisdictionId">
                        <b-td>Jurisdiction:</b-td>
                        <b-td>{{ quote.courtJurisdictionName }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-td>Service Type:</b-td>
                        <b-td>{{ quote.serviceTypeName }}</b-td>
                    </b-tr>
                    <b-tr v-if="quote.serviceDelayId">
                        <b-td>Turnaround:</b-td>
                        <b-td>{{ quote.serviceDelayName }}</b-td>
                    </b-tr>
                    <b-tr class="font-weight-bold">
                        <b-td>Estimated Costs:</b-td>
                        <b-td>{{ formatAsCurrency(quote.calculatedTotalAmount) }}</b-td>
                    </b-tr>
                    <b-tr class="font-weight-bold">
                        <b-td>Deposit:</b-td>
                        <b-td>{{ formatAsCurrency(quote.calculatedDepositAmount) }}</b-td>
                    </b-tr>
                </b-table-simple>
            </div>
        </div> <!-- panel 2 -->
    </div>
</template>

<script>
    import Vue from 'vue';
    import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
    import axios from 'axios';
    import { CalendarPlugin, DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';

    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import { extend, localize } from 'vee-validate';
    import { required, email } from 'vee-validate/dist/rules';
    import en from 'vee-validate/dist/locale/en.json';
    extend('required', required);
    extend('email', email);
    localize('en', en);

    import ErrorsMixin from '../mixins/ErrorsMixin';
    import DateTimeMixin from '../mixins/DateTimeMixin';
    import Select2 from './Select2';
    import NumbersMixin from '../mixins/NumbersMixin';
    
    Vue.use(BootstrapVue);
    Vue.use(BootstrapVueIcons);
    Vue.use(CalendarPlugin);
    Vue.use(DatePickerPlugin);
    Vue.component('validation-provider', ValidationProvider);
    Vue.component('validation-observer', ValidationObserver);
    Vue.component('select2', Select2);

    export default {
        name: 'QuoteNew',
        mixins: [ErrorsMixin, DateTimeMixin, NumbersMixin],
        props: {
            apiBaseUrl: {
                type: String,
                required: true
            },
            clientUserAccount: {
                type: Object,
                default: null
            }
        },
        data: function () {
            return {
                currentStep: 1,
                choices: [],
                hasExistingAccount: null,
                currentClientUserAccount: this.clientUserAccount,
                quoteOrderTypes: null,
                selectedQuoteOrderType: null,
                //locationOptions: [{ text: 'Select a state', value: null }, 'NSW', 'QLD', 'VIC', 'TAS', 'SA', 'WA', 'ACT', 'NT'],
                locationOptions: [],
               
                courtRegistries: null,
                courtJurisdictions: null,
                firstSittingDate: null,
                serviceTypes: null,
                selectedServiceType: null,
                serviceDelays: null,

                sittingDate: null,

                quoteRequest: {
                    contactEmail: '',
                    numberOfEmails: 3,
                    contactEmails: [ ''], // array for handling multiple emails
                    createAccount: true,
                    clientName: '',
                    contactGivenNames: '',
                    contactLastName: '',
                    contactPhone: '',
                    contactPhoneNumbers: [''], // new array for handling multiple phone numbers
                    quoteOrderTypeId: null,
                    matterInformation: null,
                    courtRegistryId: null,
                    courtJurisdictionId: null,
                    location: null,
                    
                    sittingDates: null,
                    estimatedDuration: null,
                    estimatedDurationUnits: 'Days',
                    
                    serviceTypeId: null,
                    serviceDelayId: null,
                },
                quote: null,

                // login stuff
                loginEmail: '',
                loginPassword: '',

                jurisdictionOptions: [],
                serviceTypeOptions: [],
                serviceDelayOptions: [],

                showGeneralDetails: 1,
                showMatterDetails: 1,
                showSittingDetails: 1,
                showCreditCardForm: 0,
                
                showForgottenPasswordForm: 0, 

                showSpinner: false,
                resetQuoteButtonDisabled: false,
                requestQuoteButtonDisabled: false
            }
        },
        computed: {

            /* probably obsolete: 1/12/2022 Josef
            xxx: function () {

                var plusButtonDisabled = true;
                console.log('before loop');
                for (var i = 0; i < this.quoteRequest.contactEmails.length; i++) 
                {
                    console.log('in for ' + i);
                    if (this.quoteRequest.contactEmails[i].indexOf('@') != -1) {
                        console.log('setting to false');
                        plusButtonDisabled = false;
                        //break;
                    }
                }
                console.log('returning ...');
                return plusButtonDisabled;

            },*/

            emailArrayLength: function () {
                return this.quoteRequest.contactEmails.length;
            },
            contactPhoneNumbersArrayLength: function () {
                return this.quoteRequest.contactPhoneNumbers.length;
            },
            courtJurisdictionSelectPlaceholder: function () {
                if (!this.quoteRequest.courtRegistryId) return "Select a court/tribunal/other first";
                return "Select a jurisdiction";
            },

            serviceTypeSelectPlaceholder: function () {
                if (!this.selectedQuoteOrderType) return "Select an order type first";
                if (this.selectedQuoteOrderType.detailsScreenType == 1) {
                    if (!this.quoteRequest.courtRegistryId) return "Select a court/tribunal/other first";
                }
                return "Select a service type";
            }
        },

        methods: {

            validatePositiveInteger: function (event) {
                const keyCode = event.keyCode;
                if (!((keyCode >= 48 && keyCode <= 57) || (keyCode >= 96 && keyCode <= 105) || keyCode == 8)) event.preventDefault();
            },
            explodeEmails: function (emailString) {
                return emailString.replaceAll(",", "<br>");
            },
            explodePhoneNumbers(phoneNumberString) {
                return phoneNumberString.replaceAll(",", "<br>");
            },

            addAdditionalEmail: function () {
                this.quoteRequest.contactEmails.push('');
            },
            removeAdditionalEmail: function (emailIndex) {
                this.quoteRequest.contactEmails.splice(emailIndex,1);
            },
            addAdditionalPhoneNumber: function () {
                this.quoteRequest.contactPhoneNumbers.push('');
            },
            removeAdditionalPhoneNumber: function (contactPhoneIndex) {
                this.quoteRequest.contactPhoneNumbers.splice(contactPhoneIndex, 1);
            },

            onNext: function () {
                if (this.currentStep == 1) {
                    this.currentStep = 2;
                } else if (this.currentStep == 2) {
                    this.currentStep = 3;
                } else if (this.currentStep == 3) {
                    this.currentStep = 4;
                } else if (this.currentStep == 4) {
                    this.requestQuote();
                }
            },

            onBack: function () {
                if (this.currentStep == 2) {
                    this.currentStep = 1;
                } else if (this.currentStep == 3) {
                    this.currentStep = 2;
                } else if (this.currentStep == 4) {
                    this.currentStep = 3;
                }

            },

            loadQuoteOrderTypes: function () {
                var url = this.apiBaseUrl;
                if (!url.endsWith('/')) url += '/';
                url += "quote/ordertypes";
                this.showSpinner = true;
                axios
                    .get(url)
                    .then(response => {
                        this.quoteOrderTypes = response.data;
                        this.showSpinner = false;
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showSpinner = false;
                        this.showErrorsToast(currentErrors);
                    });
            },
            quoteOrderTypeSelectionChanged: function () {
                if (this.quoteRequest.quoteOrderTypeId) {
                    this.selectedQuoteOrderType = this.$refs.quoteOrderTypeSelect.getSelectedData();
                    if (this.selectedQuoteOrderType && this.selectedQuoteOrderType.length) this.selectedQuoteOrderType = this.selectedQuoteOrderType[0];
                } else {
                    this.selectedQuoteOrderType = null;
                }
                this.quoteRequest.courtRegistryId = null;
                this.quoteRequest.courtJurisdictionId = null;
                this.quoteRequest.serviceTypeId = null;
                this.selectedServiceType = null;
                this.quoteRequest.serviceDelayId = null;
                if (this.selectedQuoteOrderType && (this.selectedQuoteOrderType.detailsScreenType == 1)) { //we have to work with the court details screen layout
                    this.serviceTypes = null;
                    this.serviceDelays = null;
                } else {
                    this.loadServiceTypes();
                }
            },

            loadCourtRegistries: function () {
                var url = this.apiBaseUrl;
                if (!url.endsWith('/')) url += '/';
                url += "quote/courtregistries";
                this.showSpinner = true;
                axios
                    .get(url)
                    .then(response => {
                        this.courtRegistries = response.data;
                        this.showSpinner = false;
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showSpinner = false;
                        this.showErrorsToast(currentErrors);
                    });
            },
            courtRegistrySelectionChanged: function () {
                if (this.quoteRequest.courtRegistryId) {
                    this.loadCourtJurisdictions();
                    this.loadServiceTypes();
                } else {
                    this.courtJurisdictions = null;
                    this.serviceTypes = null;
                    this.serviceDelays = null;
                }
                this.quoteRequest.courtJurisdictionId = null;
                this.quoteRequest.serviceTypeId = null;
                this.selectedServiceType = null;
                this.quoteRequest.serviceDelayId = null;
            },

            loadCourtJurisdictions: function () {
                var url = this.apiBaseUrl;
                if (!url.endsWith('/')) url += '/';
                url += "quote/courtjurisdictions/" + this.quoteRequest.courtRegistryId;
                this.showSpinner = true;
                axios
                    .get(url)
                    .then(response => {
                        this.courtJurisdictions = response.data;
                        this.showSpinner = false;
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showSpinner = false;
                        this.showErrorsToast(currentErrors);
                    });
            },

            sittingDatesSelectionChanged: function (args) {

                if (args) {
                    this.quoteRequest.sittingDates = args.values;
                    this.recalculateUnits();
                }
                var firstSittingDateChanged = false;
                if ((this.quoteRequest.sittingDates != null) && (this.quoteRequest.sittingDates.length > 0)) {
                    var newFirstSittingDate = this.quoteRequest.sittingDates[0];
                    for (var i = 1; i < this.quoteRequest.sittingDates.length; i++) {
                        if (this.quoteRequest.sittingDates[i].valueOf() < newFirstSittingDate.valueOf())
                            newFirstSittingDate = this.quoteRequest.sittingDates[i];
                    }
                    firstSittingDateChanged = (this.firstSittingDate == null) || (this.firstSittingDate.valueOf() != newFirstSittingDate.valueOf());
                    this.firstSittingDate = newFirstSittingDate;
                } else {
                    firstSittingDateChanged = (this.firstSittingDate != null);
                    this.firstSittingDate = null;
                    this.sittingDate = null;
                }
                if (firstSittingDateChanged) {
                    this.loadServiceTypes();
                }
            },

            recalculateUnits: function () {
                switch (this.quoteRequest.estimatedDurationUnits) {
                    case "Days":
                        this.quoteRequest.estimatedDuration = this.quoteRequest.sittingDates.length;
                        break;
                    case "Hours":
                        this.quoteRequest.estimatedDuration = this.quoteRequest.sittingDates.length * 8;
                        break;
                    case "Minutes":
                        this.quoteRequest.estimatedDuration = this.quoteRequest.sittingDates.length * 8 * 60;
                        break;
                    default:
                        this.quoteRequest.estimatedDuration = null;
                }
            },
          
            loadServiceTypes: function () {
                this.serviceTypes = null;
                this.quoteRequest.serviceTypeId
                if (((this.quoteRequest.courtRegistryId != null) || (this.quoteRequest.quoteOrderTypeId != null)) &&
                    (this.firstSittingDate != null)) {
                    var url = this.apiBaseUrl;
                    if (!url.endsWith('/')) url += '/';
                    url += "quote/servicetypes/";
                    if (this.quoteRequest.courtRegistryId) {
                        url += "bycourtregistry/" + this.quoteRequest.courtRegistryId;
                    } else {
                        url += "byquoteordertype/" + this.quoteRequest.quoteOrderTypeId;
                    }
                    url += "/" + this.formatDateTime(this.firstSittingDate, 'YYYY-MM-DD', false, false);
                    this.showSpinner = true;
                    axios
                        .get(url)
                        .then(response => {
                            this.serviceTypes = response.data;
                            this.showSpinner = false;
                        })
                        .catch(ex => {
                            var currentErrors = this.handleAxiosException(ex);
                            this.showSpinner = false;
                            this.showErrorsToast(currentErrors);
                        })
                        .finally(() => {
                            this.serviceTypeSelectionChanged();
                        });
                }
            },
            serviceTypeSelectionChanged: function () {
                if (this.quoteRequest.serviceTypeId) {
                    this.selectedServiceType = this.$refs.serviceTypeSelect.getSelectedData();
                    if (this.selectedServiceType && this.selectedServiceType.length) this.selectedServiceType = this.selectedServiceType[0];
                } else {
                    this.selectedServiceType = null;
                }
                this.loadServiceDelays();
            },

            loadServiceDelays: function () {
                this.serviceDelays = null;
                this.quoteRequest.serviceDelayId = null;
                if (((this.quoteRequest.courtRegistryId != null) || (this.quoteRequest.quoteOrderTypeId != null)) &&
                    (this.firstSittingDate != null) && (this.selectedServiceType != null) && (this.selectedServiceType.requiresServiceDelay)) {
                    var url = this.apiBaseUrl;
                    if (!url.endsWith('/')) url += '/';
                    url += "quote/servicedelays/";
                    if (this.quoteRequest.courtRegistryId) {
                        url += "bycourtregistry/" + this.quoteRequest.courtRegistryId;
                    } else {
                        url += "byquoteordertype/" + this.quoteRequest.quoteOrderTypeId;
                    }
                    url += "/" + this.formatDateTime(this.firstSittingDate, 'YYYY-MM-DD', false, false);
                    url += "/" + this.selectedServiceType.serviceTypeId;
                    this.showSpinner = true;
                    axios
                        .get(url)
                        .then(response => {
                            this.serviceDelays = response.data;
                            this.showSpinner = false;
                        })
                        .catch(ex => {
                            var currentErrors = this.handleAxiosException(ex);
                            this.showSpinner = false;
                            this.showErrorsToast(currentErrors);
                        });
                }
            },

            /*
            submitGeneralDetails: function() {

                alert('validating general details ... going to server');
                console.log(JSON.stringify(this.formConfiguration));
                this.showMatterDetails = 1;
            },
            */

            requestQuote: function () {
                var data = {
                    ...this.quoteRequest,
                    contactEmail: '',
                    contactPhone: ''
                };
                for (var i = 0; i < data.contactEmails.length; i++) {
                    if (data.contactEmails[i] && data.contactEmails[i].length) {
                        if (data.contactEmail.length) data.contactEmail += ',';
                        data.contactEmail += data.contactEmails[i];
                    }
                }
                delete data.contactEmails;
                for (i = 0; i < data.contactPhoneNumbers.length; i++) {
                    if (data.contactPhoneNumbers[i] && data.contactPhoneNumbers[i].length) {
                        if (data.contactPhone.length) data.contactPhone += ',';
                        data.contactPhone += data.contactPhoneNumbers[i];
                    }
                }
                delete data.contactPhoneNumbers;
                if (data.sittingDates) {
                    for (i = 0; i < data.sittingDates.length; i++) {
                        data.sittingDates[i] = this.formatDateTime(data.sittingDates[i], 'YYYY-MM-DD', false, false);
                    }
                }
                var url = this.apiBaseUrl;
                if (!url.endsWith('/')) url += '/';
                url += "quote/request";
                this.showSpinner = true;
                axios
                    .post(url, JSON.stringify(data),
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    .then(response => {
                        this.quote = response.data;
                        this.showSpinner = false;
                        this.$bvToast.toast('Your estimation has been produced. A copy has been sent to the email address(es) provided.', {
                            title: 'Estimation successful:',
                            variant: 'success',
                            appendToast: true
                        });
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showSpinner = false;
                        this.showErrorsToast(currentErrors);
                    });
                
            },

            login: function () {
                var loginDetails = {
                    email: this.loginEmail,
                    password: this.loginPassword
                };
                var url = this.apiBaseUrl;
                if (!url.endsWith('/')) url += '/';
                url += "account/login";
                axios
                    .post(url, JSON.stringify(loginDetails),
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    .then(() => {
                        this.$bvToast.toast('User successfully logged in', {
                            title: 'Login Successful',
                            variant: 'success',
                            appendToast: true
                        });
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },

            requestPassword: function () {
                var loginDetails = {
                    email: this.loginEmail,
                };
                var url = this.apiBaseUrl;
                if (!url.endsWith('/')) url += '/';
                url += "account/passwordReset";
                axios
                    .post(url, JSON.stringify(loginDetails),
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    .then(() => {
                        this.$bvToast.toast('User successfully logged in', {
                            title: 'Login Successful',
                            variant: 'success',
                            appendToast: true
                        });
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },

            acceptQuote: function () {
                this.showCreditCardForm = 1;
            },

            forgotPassword: function () {
                this.showForgottenPasswordForm = 1;
            },

            backToLogin: function () {
                this.showForgottenPasswordForm = 0;
            },

            resetQuoteForm() {

                this.quoteRequest = {
                    contactEmail: null,
                    createAccount: true,
                    clientName: null,
                    contactGivenNames: null,
                    contactLastName: null,
                    contactPhone: null,

                    quoteOrderTypeId: null,

                    matterInformation: '',
                    location: null,
                    courtRegistryId: null,
                    courtJurisdictionId: null,

                    sittingDates: '',
                    estimatedDurationUnits: 'Days',
                    estimatedDuration: null,

                    serviceTypeId: null,
                    serviceDelayId: null,

                    costs: 'AUD 1,500', // will come from server
                };
            },

            backToQuoteDetails() {

                this.showPanel2 = false;
                
                this.requestQuoteButtonDisabled = false;
                this.resetQuoteButtonDisabled = false;
                this.showPanel1 = true;
            }
          
        }, // methods

        created: function () {

            var url = this.apiBaseUrl;
            if (!url.endsWith('/')) url += '/';
            url += "referencedata/list/Contact.State.Choices"

            axios
                .get(url)
                .then(response => {
                    this.locationOptions = response.data
                })
                .catch(ex => {
                    var currentErrors = this.handleAxiosException(ex);
                    this.showErrorsToast(currentErrors);
                });
        },

        mounted: function () {
            this.hasExistingAccount = false;
            //this.quoteRequest.clientName = 'company';
            //this.quoteRequest.contactGivenNames = 'first';
            //this.quoteRequest.contactLastName = 'last';
            //this.quoteRequest.contactEmail = 'email@company.com';
            //this.quoteRequest.contactPhone = '123456';
            
            this.loadQuoteOrderTypes();
            this.loadCourtRegistries();
        }

    } // export default
</script>

<style scoped>
    h4 {
        
        font-weight: bold;
        margin-bottom: 20px;

        
    
    }
    h5 {
        color: #00AEEF;
        margin-top: 20px;
    }

    .box {
        float: left;
        margin: 20px;
        padding: 20px;
        border: 1px solid #BBB;
        width: 450px;
        background-color: #eeeeee;
        border-radius: 10px;
    }

    div[role="radiogroup"] label.active.disabled {
        color: #fff;
        background-color: #007bff;
        border-color: #007bff;
    }

    .e-calendar {
        min-width: 100% !important;
        max-width: 100% !important;
    }
</style>